import { lazy } from "react";

export const LoginPage = lazy(() => import("components/Pages/auth/LoginPage"));
export const ForgotPassword = lazy(() => import("components/Pages/auth/ForgotPassword"));
export const NoAccessPage = lazy(() => import("components/Pages/auth/NoAccessPage"));
export const HomePage = lazy(() => import("components/Pages/home/HomePage"));
export const ClientPage = lazy(() => import("components/Pages/client/ClientPage"));
export const StPage = lazy(() => import("components/Pages/st/StPage"));
export const DemandePage = lazy(() => import("components/Pages/demande/DemandePage"));
export const CommandePage = lazy(() => import("components/Pages/commande/CommandePage"));
export const AdminPage = lazy(() => import("components/Pages/admin/AdminPage"));
